import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { GSDevTools } from 'gsap/GSDevTools'

const lib = require('../library')
const prod = process.env.NODE_ENV === 'production'

gsap.registerPlugin(CSSRulePlugin, GSDevTools)

export default class Offcanvas {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.trigger = document.querySelectorAll('[data-offcanvas-trigger]')
    this.close = document.querySelectorAll('[data-offcanvas-close]')
    this.screen = this.el.querySelector('[data-offcanvas-screen]')
    this.canvas = this.el.querySelector('[data-offcanvas]')
    this.nav = this.el.querySelector('[data-offcanvas-body]')
    this.body = document.querySelector('body')
    this.closeCls = 'hidden'
    this.ease = 'power2.inOut'
    this.bodyOpenCls = 's-scrolling-disabled'
  }

  init() {
    this.trigger.forEach((trigger) => {
      trigger.addEventListener('click', this.handleOpen)
    })
    this.close.forEach((trigger) => {
      trigger.addEventListener('click', this.handleClose)
    })
  }

  handleOpen = () => {
    this.el.classList.remove(this.closeCls)
    this.canvas.classList.add('fixed')
    this.canvas.classList.remove('hidden')
    this.body.classList.add(this.bodyOpenCls)
    this.animateIn()
  }

  handleClose = () => {
    this.body.classList.remove(this.bodyOpenCls)
    this.animateOut()
  }

  animateIn() {
    const tlStack = gsap.timeline({
      defaults: { duration: 0.25, opacity: 0, ease: this.ease },
    })

    const items = this.body.querySelectorAll('[data-sequence]')
    // Stats
    tlStack
      .fromTo(
        this.screen,
        {
          opacity: 0,
        },
        {
          opacity: 0.95,
        },
      )
      .fromTo(
        this.nav,
        {
          x: 30,
          opacity: 0,
        },
        {
          x: 0,
          opacity: 1,
        },
        '<',
      )

    // If there are any data-sequence items, animate those in.
    tlStack.eventCallback('onStart', () => {
      const items = this.body.querySelectorAll('[data-sequence]')
      const totalMax = 3
      let durationCalc = totalMax / items.length

      if (durationCalc > 0.3) {
        durationCalc = 0.3
      } else if (durationCalc < 0.1) {
        durationCalc = 0.1
      }

      const timing = {
        duration: durationCalc,
        stagger: durationCalc - durationCalc / 1.15,
        delay: 0.1,
      }

      if (items.length) {
        const itemsTl = gsap.timeline({
          defaults: {
            duration: timing.duration,
            opacity: 0,
            ease: 'back',
          },
        })
        itemsTl.from(
          items,
          {
            delay: timing.delay,
            opacity: 0,
            x: 50,
            stagger: timing.stagger,
          },
          '-=.05',
        )
      }
    })
    // lib.reInitDeferModules("GridBg");
  }

  animateOut() {
    const tlStackOut = gsap.timeline({
      defaults: { duration: 0.3, opacity: 0, ease: this.ease },
    })
    // Stats
    tlStackOut
      .to(this.screen, {
        opacity: 0,
      })
      .to(
        this.nav,
        {
          x: 30,
          opacity: 0,
        },
        '<',
      )

    tlStackOut.eventCallback('onComplete', () => {
      this.el.classList.add(this.closeCls)
      this.canvas.classList.remove('fixed')
      this.canvas.classList.add('hidden')
    })
  }
}
